/**
 * Cloudinary delivery URLs for the door renders shown on the product detail
 * page. Same URL builder as the planner frontend (`@planner/shared`), so the
 * admin portal shows exactly the image a customer would see. Configure
 * VITE_CLOUDINARY_CLOUD_NAME to enable; unset, public ids pass through as-is
 * and the page shows placeholders.
 */
import { cloudinaryImageUrl, type CdnImageOptions } from '@planner/shared';

function cloudName(): string | undefined {
  return import.meta.env.VITE_CLOUDINARY_CLOUD_NAME;
}

export function cdnEnabled(): boolean {
  return Boolean(cloudName());
}

export function cdnImageUrl(imageId: string, options: CdnImageOptions = {}): string {
  return cloudinaryImageUrl(imageId, cloudName(), options);
}
